import * as React from 'react';
import WebGLDirector from '../../webGL/WebGLDirector';
import WebGLCartesianCoordinates from '../../webGL/shapes/composites/WebGLCartesianCoordinates';
import Color from '../../webGL/Color';
import GLComponent from './GLComponent';

export default class Vectors1Component extends GLComponent {

	componentDidMount () {
		const director = new WebGLDirector(this.canvas, this.props.width, this.props.height, this.textOverlay);

		director.addShape(WebGLCartesianCoordinates.create(-1, -1, 1, 1, 20, 20));

		this.drawVector(director, 0, 0, 1, 3, Color.cyan(), true);
		this.drawVector(director, -5, 1, 1, 3, Color.cyan(), true);
		this.drawVector(director, 0, 0, 7, 4, Color.pink(), true);
		this.drawVector(director, -5, -5, 7, 4, Color.pink(), true);

		director.drawScene();
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/lesson/WebGL/Vectors1Component.tsx